import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
    page: {
        display: "flex",
        flexDirection: "column",
        height: "100vh",
    },
    realtimeEventsErrorBanner: {
        height: "50px",
    },
    mosaic: {
        backgroundColor: theme.palette.common.black,
    },
    loaderContainer: {
        display: "flex",
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "2.5rem",
        padding: "1rem 2.25rem",
        backgroundColor: theme.palette.common.white,
    },
    loader: {
        width: "2.25rem",
        height: "2.25rem",
        marginRight: "1rem",
    },
}));
